import {isNotNil} from 'ramda';

import type {ConfiguratorBundleResponseBody} from '@dms/api/new-vehicle';

export const getVariantLabel = (
  variantId: string,
  bundle: ConfiguratorBundleResponseBody | undefined
) => {
  const variant = bundle?.variants.find(({id}) => id === variantId);
  const trim = bundle?.trims.find(({id}) => id === variant?.trimId);
  const engine = bundle?.engines.find(({id}) => id === variant?.engineId);
  return isNotNil(trim) && isNotNil(engine) ? `${trim.name} · ${engine.name}` : undefined;
};
